import React, { useState, useEffect } from "react";
const EmptyDamageClassForm = props => {
    return <div className="details_form info_text">Please choose the class of damage to show the details</div>;
}

export default (EmptyDamageClassForm);